import React, { Component } from "react";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Box from '@material-ui/core/Box';
import { Field, reduxForm, change } from 'redux-form';

import {
    renderTextField,
} from '../../utils/engageComponents';

//material
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && (
                <Box p={3}  style={{padding:'0px', margin:'0px'}}>
                    <Grid >{children}</Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const validate = (values) => {
    const errors = {};

    return errors;
};


class TranslationField extends Component{
    constructor(props){
        super(props);

        this.state= {
            activeTab: (props && props.activeTab)? props.activeTab : 0,
            inputData: (props && props.inputData)? props.inputData : undefined,
            onChangeHandler: (props && props.onChangeHandler)? props.onChangeHandler : undefined,
        };
    };

    a11yProps = (index) => {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    };

    componentDidMount(){
        if(this.state.inputData && this.state.inputData.length > 0){

            for(let i=0; i< this.state.inputData.length;i++){
                const option = this.state.inputData[i]

                const lenguageCode = option && option.languageCode? option.languageCode : undefined;

                if(!lenguageCode) continue;
                this.props.dispatch(change('TranslationForm', `fieldTranslation_${lenguageCode}`, (option && option.name)? option.name : ''));
            }
        }


    }

    GetTranslationOptions = ({inputData,onChangeHandler}) =>{
        const options = (inputData && inputData.length > 0)? inputData.map(translationOption => translationOption.languageCode): undefined;

        if(!inputData || !options || !onChangeHandler) return (<Grid item container></Grid>);

        return(
            <Grid item container>
                <this.GetTabsHeaders options={options}/>
                <this.GetTranslationContent inputData={inputData} onChangeHandler={onChangeHandler}/>
            </Grid>
        );        
    }

    GetTranslationContent = ({inputData, onChangeHandler}) =>{
        if(!inputData || inputData.length === 0) return <Grid item container></Grid>

        return(
            <Grid item container>
                <SwipeableViews
                    axis={'x' === 'rtl' ? 'x-reverse' : 'x'}
                    index={this.state.activeTab}
                    onChangeIndex={this.onTabChangeHandler}
                    style={{ width: '100%'}}
                >
                    {
                        inputData.map((obj, index) =>
                            {
                                const languageCode = (obj && obj.languageCode)? obj.languageCode : undefined;

                                return(
                                    <TabPanel value = {this.state.activeTab} index={index} dir={'x'} >
                                        <Grid item container style={{padding:'10px 0'}}>
                                            <Field 
                                                idToSet={`fieldTranslation_${languageCode}`}
                                                name={`fieldTranslation_${languageCode}`}
                                                label={obj && obj.fieldLabel?obj.fieldLabel: 'Name'}
                                                checked={this.state.isAdminAppAppDetails? this.state.isAdminAppAppDetails : false}
                                                onChange={(e)=> onChangeHandler? onChangeHandler({languageCode: (obj && obj.languageCode)? obj.languageCode: undefined, value: (e && e.target && e.target.value)? e.target.value : undefined }) : undefined}
                                                value = {(obj && obj.name)? obj.name : ''}
                                                component={renderTextField}
                                                labelInLeft={false}
                                                stylesLabel={{}}
                                            />
                                        </Grid>
                                    </TabPanel>
                                )
                            }
                        )
                    }
                    
                </SwipeableViews>
            </Grid>
        )
    }

    GetTabsHeaders = ({options}) =>{

        if(!options) return <Grid item container></Grid>

        const styles={
            tabStyles:{
                backgroundColor: '#1f1f1f',
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
                color: 'white',
                fontFamily: 'Gotham-Bold',
                fontSize: '16px',
                textTransform: 'none',    
            },        
            SelectedTabStyle: {
                backgroundColor: '#454446',
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
                color: 'white',
                fontFamily: 'Gotham-Bold',
                fontSize: '16px',
                textTransform: 'none',    
            }
        };

        return(
            <Grid item container  alignContent='flex-start' justify='center' style={{fontSize: '12px' }}>
                <AppBar position="static" color="default" elevation={0} style={{ backgroundColor: '#2a2a2b' }}>
                    <Tabs
                        value={this.state.activeTab}
                        onChange={this.onTabChangeHandler}
                        TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                        variant="fullWidth"
                        aria-label="full width tabs community"
                    >
                        {
                            options.map(
                                (option, index) => 
                                 (<Tab className="setupInfoSection" label={`${option.toUpperCase()}` } style={(this.state.activeTab === index) ? styles.SelectedTabStyle : styles.tabStyles} {...this.a11yProps(index)} disableRipple={true} disableFocusRipple={true} />)
                            )
                        }
                    </Tabs>
                </AppBar>
            </Grid>
        );    
    }

    //Methods
    onTabChangeHandler = (e, step) =>{
        try{
            this.setState({ activeTab: step })
        }catch(err){
            return undefined;
        }
    }


    render(){
        return (
            <Grid item container >
                <this.GetTranslationOptions inputData = {this.props.inputData} onChangeHandler={this.props.onChangeHandler}/>
            </Grid>
        )        
    }
};


function mapStateToProps(state, ownProps){

}
export default connect(mapStateToProps, {})(reduxForm({
    form: 'TranslationForm',
    validate,
    enableReinitialize: true,
})(TranslationField));;